import React from "react";
import "./Footer.scss";

export function Footer() {
  const unidad = "Unidad de Docencia y Capacitación";
  const desarrollo = "Equipo de desarrollo web";

  return (
    <div className="footer">
      <div className="footer__noResponsive">
        © 2023-2024 | {unidad} | <a href="/desarrolladores">{desarrollo}</a>
      </div>

      <div className="footer__Responsive">
        © 2023-2024 | {unidad}
        <br></br>
        <a href="/desarrolladores">{desarrollo}</a>
      </div>
    </div>
  );
}
